import React from "react";
import styles from "./whyChooseService.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCode, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import LazyText from "../../../common/imagescroll/LazyText";
import CTAButton from "../../../v2/common/CTA-Button/cta-button";

const WhyChooseService: React.FC = () => {
    const { t } = useTranslation();


    const whyChooseService = [
        {
            title: "Clear Communication",
            description: "We keep you informed at every stage, ensuring clarity, alignment, and no surprises."
        },
        {
            title: "Scalable Architecture",
            description: "Applications designed to grow with your business without costly rebuilds."
        },
        {
            title: "Reliable Performance",
            description: "Production-ready systems built for speed, stability, and real-world usage."
        },
        {
            title: "Strong Security Practices",
            description: "Security-first development to protect your data and users at every layer."
        },
        {
            title: "No Hidden Fees",
            description: "Transparent pricing and clear scope so you always know what you’re paying for."
        }
    ];

    return (
        <section className={styles.sectionWrapper}>

            {/* CENTERED TITLES INSIDE SECTION */}
            <LazyText>
                <h1 className="sectionTitle" style={{color:"darkturquoise"}}>
                    {/*{String(t('homePage.whyUsTitle'))}*/}
                    Why Choose This Service
                </h1>
            </LazyText>


            {/* YOUR GRID — UNTOUCHED */}
            <div className={styles.gridContainer}>
                {whyChooseService.map((benefit, index) => (

                    <div className={styles.card}>
                        <div className={styles.card_title}>
                            {benefit.title}
                        </div>
                        <div className={styles.content}>
                            <p>
                                {benefit.description}
                            </p>
                        </div>
                    </div>

                ))}
            </div>
            <CTAButton text={"Get a Free Quote"} />
        </section>
    );
};

export default WhyChooseService;
